import {
  Box,
  FormControl,
  Input,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core"
import React from "react"
import { ANIOS_LIST, COLOR_TEXT_HINT, COLOR_WARNING, MESES_LIST, Quincena } from "./constants"

export { MESES_LIST }

export interface FiltrosSup {
  anio: string
  mes: string
  mesNumero: number
  quincena: string
}

interface Props {
  filtrosSup: FiltrosSup
  setFiltrosSup: React.Dispatch<React.SetStateAction<FiltrosSup>>
}

const useStyles = makeStyles({
  containerFiltros: {
    display: "flex",
    flexDirection: "row",
    gap: "1px",
    marginBottom: "8px",
    width: "100%",
  },
  btnFiltro: {
    backgroundColor: COLOR_WARNING,
    borderRadius: 12,
    border: "1px solid rgba(255, 255, 255, 0.5)",
    padding: "6px 12px",
    flex: 1,
    "& .MuiInputLabel-root": {
      position: "relative",
      transform: "none",
      fontSize: "0.75rem",
      fontWeight: "bold",
      color: COLOR_TEXT_HINT,
    },
    "& .MuiSelect-select": {
      fontSize: "0.9rem",
      color: "#1a1a1a",
    },
  },
})

const QUINCENA_OPTIONS = [
  { value: Quincena.Q1, label: "Primera Quincena" },
  { value: Quincena.Q2, label: "Segunda Quincena" },
  { value: Quincena.ALL, label: "Todo el Mes" },
]

export const CustomFilters = ({ filtrosSup, setFiltrosSup }: Props) => {
  const classes = useStyles()

  const handleChange =
    (field: string) => (e: React.ChangeEvent<{ value: unknown }>) => {
      const value = e.target.value as string
      setFiltrosSup((prev) => {
        if (field === "mes") {
          return { ...prev, mes: value, mesNumero: MESES_LIST.indexOf(value) + 1 }
        }
        return { ...prev, [field]: value }
      })
    }

  return (
    <Box className={classes.containerFiltros}>
      <Box className={classes.btnFiltro}>
        <FormControl fullWidth>
          <InputLabel shrink>#Año</InputLabel>
          <Select
            value={filtrosSup.anio}
            onChange={handleChange("anio")}
            input={<Input disableUnderline />}
          >
            {ANIOS_LIST.map((anio) => (
              <MenuItem key={anio} value={anio}>
                {anio}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box className={classes.btnFiltro}>
        <FormControl fullWidth>
          <InputLabel shrink>Mes</InputLabel>
          <Select
            value={filtrosSup.mes}
            onChange={handleChange("mes")}
            input={<Input disableUnderline />}
          >
            {MESES_LIST.map((m) => (
              <MenuItem key={m} value={m}>
                {m.charAt(0).toUpperCase() + m.slice(1)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box className={classes.btnFiltro}>
        <FormControl fullWidth>
          <InputLabel shrink>Quincena</InputLabel>
          <Select
            value={filtrosSup.quincena}
            onChange={handleChange("quincena")}
            input={<Input disableUnderline />}
          >
            {QUINCENA_OPTIONS.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  )
}
